var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "errPage-container" }, [
    _c(
      "div",
      { staticStyle: { background: "#fff" } },
      [
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 12 } }, [
              _c("h1", { staticClass: "text-jumbo text-ginormous" }, [
                _vm._v("\n         Oops!\n       ")
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("你没有权限去该页面")]),
              _vm._v(" "),
              _c("h6", [_vm._v("如有需要请联系管理员")]),
              _vm._v(" "),
              _c("ul", { staticClass: "list-unstyled" }, [
                _c("li", [_vm._v("或者你可以去:")]),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "link-type" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: _vm.gotoDataScreening() } },
                      [_vm._v("\n             回首页\n           ")]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("el-col", { attrs: { span: 12 } }, [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: {
                  src: _vm.errGif,
                  height: "428",
                  alt: "Girl has dropped her ice cream."
                }
              })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: { visible: _vm.dialogVisible, title: "随便看" },
            on: {
              "update:visible": function($event) {
                _vm.dialogVisible = $event
              }
            }
          },
          [
            _c("img", {
              staticClass: "pan-img",
              attrs: { src: _vm.ewizardClap }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }